module.exports = __webpack_public_path__ + "26acfb8e.webp";